import React from "react";
// import PropTypes from 'prop-types'

function TextInput(props) {   
  const {t} = props
  const errors = props.validation && props.validation.errors ? props.validation.errors : "";
  const isDirty = props.validation && props.validation.dirty ? props.validation.dirty : false;
  const formClass = errors[props.name] && isDirty[props.name] ? "form-group invalid" : "form-group";
  return (
    <div className={formClass}>
      <label htmlFor={props.id}>{props.label} {props.required && <span>*</span>}</label>
      <input
        id={props.id}
        name={props.name}
        value={props.value}
        type="text"
        className="form-control"
        placeholder={props.placeholder}
        onChange={props.onChange}
        required={props.required}
        maxLength={props.maxLength}
        disabled={props.disabled}
        readOnly={props.readOnly}
      />
      {errors[props.name] && isDirty[props.name] && (<div className="error-message">{t(errors[props.name])}</div>)}
      {/* {props.error.length && } */}
    </div>
  );
}

// TextInput.propTypes = {
//     id: PropTypes.string.isRequired,
//     name: PropTypes.string.isRequired,
//     label: PropTypes.string.isRequired,
//     onChange: PropTypes.string.isRequired,
//     value: PropTypes.string,
//     error: PropTypes.string
// };

// TextInput.defaultProps = {
//     error: "This is a required field."
// }

export default TextInput;
